<template>
  <div>
    <p>
      {{ $t('check') }}
    </p>
    <ol>
      <li>
        {{ $t('p1') }}
        <br>
        <img
          v-if="image"
          :src="image"
          style="width:30%;height:30%;"
          class="error-image"
          alt=""
        >
      </li>
      <li>
        {{ $t('p2') }}
      </li>
      <li>
        {{ $t('p3') }}
      </li>
      <li>
        {{ $t('p4') }}
      </li>
    </ol>
    <br>
    <p>
      {{ $t('more') }} <a target="_blank" href="https://www.google.com/search?q=firefox+camera+permissions">{{ $t('support') }}</a>.
    </p>
  </div>
</template>

<script>
import firefoxLockImage from '../../../assets/img/firefox_lock.png';

export default {
  name: 'NotAllowedFirefox',
  computed: {
    image() {
      return firefoxLockImage;
    },
  },
};
</script>

<style scoped>

</style>

<i18n locale="en" lang="yaml">
check: You have not given permission to access your camera or microphone.
p1: To the left of the site address, click on the crossed-out camera or microphone icon;
p2: Remove the ban on camera and microphone access;
p3: Refresh the page
p4: Click Allow when Firefox requests access again.
more: If these recommendations do not help, use
support: the Firefox support service
</i18n>

<i18n locale="ru" lang="yaml">
check: Вы не дали разрешение на доступ к камере или микрофону.
p1: Слева от адреса сайта нажмите на значок перечёркнутой камеры или микрофона;
p2: Сбросьте запрет на доступ к камере и микрофону;
p3: Обновите страницу;
p4: Нажмите Разрешить, когда браузер снова запросит доступ.
more: Если рекомендации не помогли, воспользуйтесь
support: документацией Firefox
</i18n>
